export default __webpack_public_path__ + "static/MySQL-0ac920ea25cd126c66c179f214a65f12.webp";